import { COUNTRY } from '../../interfaces/shipping.interface';
import { CREATE_INTL_SHIPMENT_REQUEST } from '../../redux/thunks/interfaces/shipping.interface';
import { getIntialState } from '../../utils/persist-state';

export interface SUPPORTING_VALUES {
  ReceiverCountry: COUNTRY;
  SenderCountry: COUNTRY;
}

export interface OVERSEAS_SHIPPING_FORM_STATE {
  currentStep: number;
  values: CREATE_INTL_SHIPMENT_REQUEST;
  supportingValues: SUPPORTING_VALUES;
}

export enum OVERSEAS_SHIPPING_FORM_TYPES {
  UPDATE_VALUE = 'UPDATE_VALUE',
  UPDATE_STEP = 'UPDATE_STEP',
  UPDATE_SUPPORTING_VALUES = 'UPDATE_SUPPORTING_VALUES',
  RESET = 'RESET',
}

// eslint-disable-next-line max-len
export const initialShippingState: OVERSEAS_SHIPPING_FORM_STATE = getIntialState(
  'overseas-shipping'
) || {
  currentStep: 1,
  values: {},
  supportingValues: {},
  locationData: {},
};

export interface OVERSEAS_SHIPPING_FORM_ACTION {
  type: OVERSEAS_SHIPPING_FORM_TYPES;
  values?: Partial<CREATE_INTL_SHIPMENT_REQUEST>;
  supportingValues?: SUPPORTING_VALUES;
  step?: number;
}

export const overseasShippingFormReducer = (
  state = initialShippingState,
  action: OVERSEAS_SHIPPING_FORM_ACTION
): OVERSEAS_SHIPPING_FORM_STATE => {
  switch (action.type) {
    case OVERSEAS_SHIPPING_FORM_TYPES.UPDATE_VALUE:
      return {
        ...state,
        values: {
          ...state.values,
          ...action.values,
        },
      };
    case OVERSEAS_SHIPPING_FORM_TYPES.UPDATE_STEP:
      return {
        ...state,
        currentStep: action.step || state.currentStep,
      };
    case OVERSEAS_SHIPPING_FORM_TYPES.UPDATE_SUPPORTING_VALUES:
      return {
        ...state,
        supportingValues: {
          ...state.supportingValues,
          ...action.supportingValues,
        },
      };
    case OVERSEAS_SHIPPING_FORM_TYPES.RESET:
      return {
        ...state,
        currentStep: 1,
        values: {} as any,
      };
    default:
      return state;
  }
};
